import { request } from '../http/request'
import { API_BASE_URL } from './config'

export const LGPD_PUBLIC_PATHS = [
  '/unsubscribe',
  '/accept-notifications',
  '/eula',
  '/privacy',
  '/maintenance',
]

class LgpdService {
  isPublicPath(path) {
    const p = String(path || '/').replace(/\/+$/, '') || '/'
    if (p === '/') return false
    return LGPD_PUBLIC_PATHS.some((x) => p === x || p.startsWith(x + '/'))
  }
  policy() {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/lgpd/policy`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
  status() {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/lgpd/status`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
  accept(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/lgpd/accept`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
  preferences(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/lgpd/preferences`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
}

export const lgpd = new LgpdService()
